export { default } from './request-equipment-service-feedback-banner';
